import { connect } from 'react-redux'
import * as selector from '../../state/manage/selector'
import * as action from '../../state/manage/action'
import ManageRoleWidgets from './ManageRoleWidgets'

const mapStateToProps = (state, props) => {
    return {
        currentRole: selector.selectCurrentRole(state),
        currentRoleId: selector.selectCurrentRoleId(state),
        roleList: selector.selectRoleList(state),
        validationMessageList: selector.selectValidationMessageList(state),
    }
}

const mapDispatchToProps = {
    changeCurrentRoleId: action.changeCurrentRoleId,
    findAllRole: action.findAllRole,
    toggleRoleWidgetAccess: action.toggleRoleWidgetAccess,
    saveRole: action.saveRole,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageRoleWidgets)



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/ManageRoleWidgetsContainer.js